import React from "react";
import { NavButton } from "./NavSearchButton";
import { MessageCircle } from "lucide-react";

const NavChatButton = ({
  onClick,
  id,
}: Pick<React.ComponentProps<typeof NavButton>, "onClick" | "id">) => {
  return (
    <NavButton id={id} onClick={onClick}>
      <MessageCircle size={25} />
    </NavButton>
  );
};

export default NavChatButton;
